import { FixProposal, StructuredResumePatch } from '../../types';

/** The `data-section-id` the preview should glow after a patch is applied, or
 *  null when the target element no longer exists post-apply (whole-entry
 *  deletes — same convention as the legacy removal flow). List sections and the
 *  contact header survive their edits, so they glow as a whole. */
const glowTargetForPatch = (patch: StructuredResumePatch): string | null => {
  switch (patch.operation) {
    case 'replace_summary':
      return 'summary';
    case 'replace_bullet':
      return patch.target.bullet_id ?? null;
    case 'replace_job_title':
    case 'add_bullet':
    case 'reorder_bullets':
    case 'move_content':
      return patch.target.experience_id ?? null;
    case 'replace_contact_field':
    case 'replace_contact_link':
    case 'delete_contact_link':
      return 'contact';
    case 'add_list_item':
    case 'replace_list_item':
    case 'delete_list_item':
      return patch.target.section;
    case 'replace_education':
    case 'remove_education_dates':
      return patch.target.education_id ?? null;
    default:
      // delete_bullet / delete_experience / delete_education: nothing left.
      return null;
  }
};

export const sectionIdForStructuredProposal = (
  proposal: FixProposal
): string | null => {
  for (const patch of proposal.patches ?? []) {
    const target = glowTargetForPatch(patch);
    if (target) return target;
  }
  return null;
};
